import { getUserSettings } from ".";

export class Company {
  public static testCompanyId(companyIds: string[]): boolean {
    const currentCompanyId = getUserSettings().company_id;
    if (currentCompanyId == null)
      return false;
    return companyIds?.includes(currentCompanyId);
  }
}